import React from "react";
import "./About.css";
import aboutMeImg from "../../../images/aboutMe-img_myimg.png"
const About = () => {
  return (
    <div>
      <div className="row my-5 px-5 d-flex align-items-center justify-content-center">
        <div className="col-md-2 social-icons">
          <a href="https://github.com/Tanmoy-Parvez" target="-blank">
            <i className="fab fa-github"></i>
          </a>
          <a href="https://www.linkedin.com/in/tanmoy-parvez/" target="-blank">
            <i className="fab fa-linkedin"></i>
          </a>
          <a href="https://www.facebook.com/TanmoyParvez23/" target="-blank">
            <i className="fab fa-facebook"></i>
          </a>
          <a href="https://www.instagram.com/tanmoyparvez/" target="-blank">
            <i className="fab fa-instagram-square" ></i>
          </a>
        </div>
        <div className="col-md-4">
          <img src={aboutMeImg} alt="" className="img-fluid w-100 p-3" />
        </div>
        <div className="col-md-6 text-start ps-3 pe-4">
          <h2 className="text-uppercase text-warning mb-3">About Me</h2>
          <p style={{ textAlign: 'justify' }}>I've been trying to learn programming for 2 years, at this time Looking back in my past, I can't find any other chapter except coding.</p>
          <p style={{ textAlign: 'justify' }}>I have become so involved with programming that coding has become an addiction. That's why when I finish a project at the right time, then I feel full of peace, joy, and a smile too.</p>
          <p style={{ textAlign: 'justify' }}>Finally, Dedicated and efficient full stack developer with 8+ months of experience in application layers, presentation layers, and databases.</p>
          <h5> <span className="text-warning">Name:</span> Tanmoy Parvez</h5>
          <h5><span className="text-warning">Email:</span> tanmoyparvez23@gmail.com</h5>
          <h5><span className="text-warning">Phone:</span> (+88) 01761067476</h5>
        </div>
      </div>
      <hr style={{ color: "white", width: "800px", margin: "0 auto" }} />
    </div>
  );
};

export default About;
